import { MetaTagsResponse } from './meta-tag';

export interface BasicStudentSocietyAttributes {
  id: string;
  name: string;
  slug: string;
  icon_url: string;
  meta_title: string;
  meta_description: string;
  meta_tags: MetaTagsResponse;
}

export interface BasicStudentSociety {
  id: string;
  type: 'basic_student_society';
  attributes: BasicStudentSocietyAttributes;
}

export interface BasicStudentSocietiesResponse {
  data: Array<BasicStudentSociety>;
  meta: { total: number };
}

export const PER_PAGE_COUNT = 20;
